// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"206":"7ec9b68b04c481ee","540":"66a52b7e43e74071","542":"eaa4ffcb13ac27ae","611":"a1c75d326b90dd9a","722":"f56261c1a65c32a9","780":"032c6c67c36faf0b","816":"3f274ffe77aa5b26","842":"dec3cad657ede2c6","912":"a3542d7040b6d8fb"}[chunkId] + ".js";
};